﻿import { sitecore, MediaQuery } from '../../Foundation';

export class StickyMenu {
    /** 
     * Full Width Carousel
     * Display an carousel that covers viewport 
     * @param {Carousel} element 
     */
    constructor(element) {
        this._refs = {
            el: element,
            placeholder: document.querySelector('.product-content'),
            menu: element.querySelector('.product-menu__items'),
            items: Array.from(element.querySelectorAll('.product-menu__item')),
            trigger: element.querySelector('.product-menu__selector-button'),
            end: element.querySelector('.product-menu__end'),
            label: element.querySelector('.product-menu__selector-item'),
            mainNavigation: (document.querySelector('.main-navigation__wrapper') == null) ? document.querySelector('.mega-menu-navigation') : document.querySelector('.main-navigation__wrapper'),
            serviceMenu: document.querySelector('.service-menu'),
            productname: element.querySelector('.product-menu__brand-link')
        };

        // Sitecore Edit Mode
        if(sitecore.isInPageEditor) {
            const oSubmenu = document.querySelector('.secondary-level-is-expanded');

            console.log(oSubmenu);
            if(oSubmenu != null) {
                const strClassname = 'has-submenu-visible';
                this._refs.el.classList.add(strClassname);

                // MainContent
                const oMainContent = document.querySelector('#main-content');
                if(oMainContent != null) {
                    oMainContent.classList.add(strClassname);
                }
            } 
        }

        this._props = {
            isScrolling: false
        };

        this._data = {};

        // Locate spots
        this._refs.spots = this._getSpots();

        // # Events
        this._reflow();
        window.addEventListener('change.mq', this._reflow.bind(this));

        if (this._refs.productname != null) {
            this._refs.productname.addEventListener('click', (e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        } 

        // # OnLoad
        if (this._refs.spots.length) {
            const oFirstSpot = this._refs.spots[0];
            this._onElementInView(oFirstSpot);
        }

        // # Scroll spy
        document.addEventListener('scroll', () => {
            this._refs.spots.forEach(item => this._onElementInView(item));
        });
         
        // # Fall-down animation
        if (this._refs.mainNavigation !== null) {
            let navigationHeight = this._refs.mainNavigation.getBoundingClientRect().height;
            if (this._refs.serviceMenu !== null) {
                navigationHeight += this._refs.serviceMenu.getBoundingClientRect().height;
            }

            this._data.navigationHeight = navigationHeight;

            this._toggl();
            document.addEventListener('scroll', this._toggl.bind(this)); 
        }
    }

    /**
     * Callback for handling when an spot is in view
     * @param {HTMLElement} item - Item (spot) in view
     */
    _onElementInView(item) {
        if (this._isElementInView(item)) {
            const
                strItemId = item.getAttribute('id'),
                oMenuItemActive = this._refs.items.filter(x => x.classList.contains('is-active')),
                oMenuItem = this._refs.items.filter(x => {
                    const strId = x.getAttribute('href').replace('#', '');

                    if (strId === strItemId) {
                        return x;
                    }
                });

            if (oMenuItemActive.length) {
                oMenuItemActive.forEach(x => x.classList.remove('is-active'));
            }

            if (oMenuItem.length) {
                oMenuItem[0].classList.add('is-active');
                // Active label
                if (this._refs.label != null) {
                    this._refs.label.innerHTML = oMenuItem[0].innerHTML;
                } 
            }
        }
    }

    /**
     * Locate an element based on scroll position + top of element
     * @param {HTMLElement} el - element to watch 
     */
    _isElementInView(el) {
        const
            bounding = el.getBoundingClientRect();

        const
            windowHeight = window.innerHeight,
            scrollY = window.scrollY || window.pageYOffset,
            scrollPosition = scrollY + windowHeight,
            elementPosition = bounding.top + scrollY;

        if (scrollPosition > elementPosition) {
            return true;
        }

        return false;
    } 

    /**
     * Toggl visiblity for menu while user either loads or scrolls on the page
     */
    _toggl() {
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        if (scrollTop > this._data.navigationHeight) {
            this._refs.el.classList.add('in-view');
            this._refs.mainNavigation.style.display = 'none';
        } else {
			if(this._refs.mainNavigation.className == 'mega-menu-navigation'){
			this._refs.mainNavigation.style.position='fixed';
			}
            this._refs.el.classList.remove('in-view');
            this._refs.mainNavigation.style.display = 'block';
        }
    }

    /**
     * Locate anchored spots within main-content area
     * @returns {Array} - Array of elements matching criteria
     */
    _getSpots() {
        let arrSpots = Array.from(document.querySelectorAll('#main-content [id]'));

        // Filter all undisered elements out of scope
        return arrSpots.filter(x => {
            if (x.tagName === "DIV" || x.tagName === "SECTION") {
                // Attribute filtering
                const strId = x.getAttribute('id');
                if (strId !== '' && !strId.includes('swiper-') && !strId.includes('video-')) {
                    return x;
                }
            }
        });
    }

    /**
     * Bind events for handling generic tasks for the component
     */
    _reflow() {
        const oMenuTrigger = this._onMenuTrigger.bind(this);

        if (this._refs.trigger != null) {
            if (MediaQuery.below('xl')) {
                this._refs.trigger.addEventListener('click', oMenuTrigger);
            } else {
                // Manual reset of menu
                this._refs.end.removeAttribute('style');
                this._refs.trigger.classList.remove('is-active');
                this._refs.trigger.removeEventListener('click', oMenuTrigger);
            }
        }

        if (this._refs.items.length) {
            this._refs.items.forEach(x => x.addEventListener('click', this._onMenuItemClick.bind(this)));
        }
    }

    /**
     * Handling of transition after user clicks on a menu item
     * @param {Event} e - Event interface 
     */
    _onMenuItemClick(e) {
        const fnTransitionEnd = (oMenuItem) => {
            // Active label
            this._refs.label.innerHTML = oMenuItem.innerHTML;

            // Reset meun items to reflect selection
            this._refs.items.forEach(x => x.classList.remove('is-active'));

            // Transition
            this._refs.end.removeAttribute('style');
            this._refs.trigger.removeEventListener('transitionend', fnTransitionEnd);

            this._props.isScrolling = false;

            // Set active menu item
            oMenuItem.classList.add('is-active');
        };

        this._props.isScrolling = true;

        if(this._refs.trigger) {
            this._refs.trigger.classList.remove('is-active');
            this._refs.trigger.addEventListener('transitionend', fnTransitionEnd(e.target));
        }
    }

    /**
     * Trigger animation of menu to fold in/out
     * @param {Event} e - Event interface 
     */
    _onMenuTrigger(e) {
        const bState = this._refs.trigger.classList.contains('is-active');

        if (bState) {
            // Remove active state
            this._refs.end.removeAttribute('style');
            this._refs.trigger.classList.remove('is-active');
        } else {
            // Add active state
            this._refs.trigger.classList.add('is-active');

            const intMenuHeight = this._refs.menu.getBoundingClientRect().height;

            this._refs.end.style.height = intMenuHeight + 'px';
        }
    }
} 